module.exports = require("./fi.d.ts");